import React from 'react';
import assign from 'object-assign';

import MenuItem from 'material-ui/MenuItem';
import SelectField from '../Common/SelectField';
import Form from '../Common/Form.react';
import MultiCheckboxSet from '../Common/MultiCheckboxSet';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import AssignmentIcon from 'material-ui/svg-icons/social/people-outline';

import AssignmentActions from '../../actions/AssignmentActionCreator';
import AssignmentStore from '../../stores/AssignmentStore';
import EventActions from '../../actions/EventActionCreator';
import { statusColours } from '../../constants/ColourConstants';


const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

const AssignmentManage = React.createClass({

    getInitialState: function() {
        return {
            id: this.props.params.id,
            name: '',
            maxUserCount: 0,
            assignment: {
                courses: [],
                users: [],
            },
            events: [],
            form: {
                course: 0,
                event: 0,
                users: []
            }
        }
    },
    componentDidMount: function() {
        AssignmentStore.addChangeListener(this.onChange);
        AssignmentActions.getById(this.props.params.id);
    },
    componentWillUnmount: function() {
        AssignmentStore.removeChangeListener(this.onChange);
    },

    render: function() {

        const colour = statusColours['default'];
        const avatarIcon = (<AssignmentIcon style={style.icon} color={colour}/>);

        return (
            <Form
                onSave={this.onSave}
                onCancel={this.onCancel}
                redirectTo="/dashboard/assignments"
                title=''
            >
                    <Card className="cent-card">
                        <CardHeader
                            title={this.state.name}
                            subtitle={this.state.description}
                            avatar={avatarIcon}
                        />
                        <CardText>


                        <SelectField
                            name="course"
                            value={this.state.form.course}
                            floatingLabelText="Course"
                            onChange={this.onCourseChange}
                            required
                        >
                            {this.state.assignment.courses.map(function(course) {
                                return (
                                    <MenuItem
                                        key={course.id}
                                        value={course.id}
                                        primaryText={course.name}
                                    />
                                )
                            })}
                        </SelectField>
                <SelectField
                    name="event"
                    value={this.state.form.event}
                    floatingLabelText="event"
                    onChange={this._onEventChange}
                    disabled={!!(!this.state.events.length)}
                    required
                >
                    {this.state.events.map(function(event) {
                        let primaryText = event.name + ' (' + new Date(event.timeStart).toLocaleDateString() + ')';
                        return (
                            <MenuItem
                                key={event.id}
                                value={event.id}
                                label={event.name}
                                primaryText={primaryText}
                            />
                        )
                    })}
                </SelectField>
                <MultiCheckboxSet
                    items={this.state.assignment.users}

                    name="users"
                    max={this.state.maxUserCount}
                    value={this.state.form.users}
                    disabled={!!(!this.state.maxUserCount)}
                    required
                />
                        </CardText>
                    </Card>
            </Form>
        )
    },

    onChange: function() {
        const assignment = AssignmentStore.getById(this.props.routeParams.id);
        if (assignment !== undefined) {
            this.setState({
                id: assignment.id,
                name: assignment.name,
                description: assignment.description
            });
        }
    },

    onCourseChange: function(e, value, index) {
        let eventList = [];
        if (this.state.assignment.courses[index].length === 1) {
            eventList = this.state.assignment.courses[index].calendar.events;
        }
        if(eventList.length === 1) {
            this.setState(assign({}, this.state, { events: eventList, form: { course: value, event: eventList[0].id } } ));
            this.onEventChange(undefined, eventList[0].id, 0, value);
        } else {
            this.setState(assign({}, this.state, { events: eventList } ));
        }

    },

    onEventChange: function(e, value, index, newCourseId) {
        const courseId = newCourseId || this.state.form.course;
        let course = this.state.assignment.courses.find(function(course, i) {
            return course.id === courseId;
        });

        const events = course.calendar.events;
        let event = events[index];
        let maxUserCount = Math.min(course.capacity, event.capacity, event.location.capacity);

        this.setState(assign({}, this.state, {
            maxUserCount: maxUserCount,
            events: events,
            form: { event: value, course: courseId }
        }));

    },
    onCancel: function() {
        window.location.href = '/dashboard/assignments';
    },
    onSave: function(data) {
        EventActions.bookUsers(data.event, data.users);
    }

});

export default AssignmentManage;
